<template>
  <div class="login">
    <div class="head">
      <div>
        <img @click="$router.push({path:'/'})" src="../assets/img/index/logo_head.png" alt="">
	      <div class="login-ent" >
          <a @click="$router.push({path:'/login',query:{from:2}})"><span>注 册</span></a>
          <a @click="$router.push({path:'/login',query:{from:1}})"><span>登 录</span></a>
          <!-- <a ><span>APP</span></a> -->
			  </div>
 	    </div>
    </div>
    <div class="alignmiddle">
      <div class="login-bg">
        <!-- 登录 -->
        <div class="reg-login">
          <div class="left-toppike" v-if="type==2">
              <i class="top-y"></i>
              <ul class="top-title">
                <li>
                    <a href="#">填写基本信息</a>
                    <img src="../assets/img/login/jindu1.png" v-if="regType==1" class="top-quan">
                    <img src="../assets/img/login/jindu.png" v-else class="top-quan">
                </li>
                <li>
                    <a href="#">手机验证</a>
                    <img src="../assets/img/login/jindu1.png" v-if="regType==2" class="top-quan">
                    <img src="../assets/img/login/jindu.png" v-else class="top-quan">
                </li>
                <li>
                    <a href="#">注册成功</a>
                    <img src="../assets/img/login/jindu1.png" v-if="regType==3" class="top-quan">
                    <img src="../assets/img/login/jindu.png" v-else class="top-quan">
                </li>
              </ul>
          </div>
          <div class="register" v-if="type==2 && regType==1">
            <div>
              <div>用户</div>
              <div @click="docReg()">医生</div>
            </div>
            <div>
              <input type="text" v-model="phone" placeholder="请输入手机号">
            </div>
            <div><input type="text" v-model="name" placeholder="请输入姓名"></div>
            <div><input type="password" autocomplete="off" v-model="password" placeholder="请输入密码"></div>
            <div><input type="password" autocomplete="off" v-model="cpassword" placeholder="请输入确认密码"></div>
            <div><input type="text" v-model="code" placeholder="请输入验证码"><canvas id='auth-code' @click="getCode()"></canvas></div>
            <div @click="next()">下一步</div>
          </div>
          <div class="register" v-if="type==2 && regType==2" v-loading="loading">
            <div>
              <div>用户</div>
              <div @click="docReg()">医生</div>
            </div>
            <div>
              <input type="text" v-model="phone" placeholder="请输入手机号">
            </div>
            <div class="phoneCode">
              <input type="text" v-model="smsCode" placeholder="请输入验证码">
              <el-button :disabled="codeBtn" type="primary" @click="codePhone()">{{codeValue}}</el-button>
            </div>
            <div @click="regComfirm()">确认提交</div>
          </div>
          <div class="register" v-if="type==2 && regType==3">
            <div>
              <div>用户</div>
              <div @click="docReg()">医生</div>
            </div>
            <div style="margin-top:100px"><img src="../assets/img/login/success.png" width="120px" alt=""></div>
            <div class="font-s-20">注册成功</div>
            <div class="color-blue cur-poin" @click="$router.push({path:'/login',query:{from:1}})">马上去登录</div>
            <div class="dis-none mar-t-50"></div>
          </div>
          <div class="login" v-if="type==1" v-loading="loading">
            <div><img src="../assets/img/index/user_img.png" alt=""><input type="text" v-model="phone" placeholder="请输入手机号"></div>
            <div><img src="../assets/img/index/psw_img.png" alt=""><input type="password" autocomplete="off" v-model="password" placeholder="请输入密码"></div>
            <div><input type="text" v-model="code" placeholder="请输入验证码"><canvas id='auth-code' @click="getCode()"></canvas></div>
            <div>
              <div class="pull-left">还没账号？<span class="color-blue" @click="$router.push({path:'/login',query:{from:2}})">立即注册</span></div>
              <div class="pull-right color-red">忘记密码?</div>
              <div class="clear-both"></div>
            </div>
            <div @click="loginBtn()">登录</div>
          </div>
        </div>
      </div>
    </div>
    <div class="login-foot">
      <div>
        <div class="pull-left">
          <div>本网站为医疗机构、医生提供专业诊断交流平台,相关行业法律法规由医疗机构、医生自行参考为注册用户提供咨询平台,咨询所得意见仅供参考,本网站不承担由此引起的任何法律责任</div>
          <div>客服电话：400-066-3138&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备案号：闽ICP备18019817号-1</div>
          <div>官方网址：www.hujyy.com</div>
          <div>联系地址：福建省莆田市荔城区电子商务大楼13层</div>
          <div>CopyRight©2017-2018 福建智康云医疗科技有限公司 版权所有</div>
        </div>
        <div class="pull-right">
          <div>智康云科技</div>
          <div><img src="../assets/img/login/erweima.png" alt=""></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
//import errImg from '../assets/img/common/demo.png'
import {mapState} from 'vuex'
export default {
  name: 'login',
  data() {
    return {
      loading:false,
      type:this.$route.query.from,
      regType:1,
      phone:'',
      name:'',
      password:'',
      cpassword:'',
      smsCode:'',
      code:'',
      setCode:'',
      codeValue:'获取验证码',
      codeBtn:false
    }
  },
  watch: {    
    '$route' (to, from) {   
      this.$router.go(0)
    }
 },
  computed:{
    ...mapState({
        userNam: state => state.userNam
    })
  },
  methods: {
    imgError(d,name) {//图片error处理
        d[name] = errImg
    },
    docReg() {
      this.$alert('医生注册请联系卫健委！', {
        confirmButtonText: '确定',
        center:true,
        callback: action => {
          
        }
      });
    },
    getCode(){
      this.setCode=(Math.floor(Math.random()*(9999-1000))+1000)+''
      let options = {
        canvasId: "auth-code",/**canvas的id*/
        txt: this.setCode,/**传入验证码内容*/
        height: 35,/**验证码高度 */
        width: 80/**验证码宽度 */
      };
      this.$common.writeAuthCode(options);
    },
    next(){
      if(!this.$common.checkPhone(this.phone)){
        this.$message({
          message: '请输入正确的11位手机号',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else if(this.name==''){
        this.$message({
          message: '请输入姓名',
          type: 'warning',
          offset:300
        });
      }else if(this.password==''){
        this.$message({
          message: '请输入密码',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else if(this.password!=this.cpassword){
        this.$message({
          message: '两次密码不一致，请重新输入！',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else if(this.setCode!=this.code){
        this.$message({
          message: '验证码不正确，请重新输入！',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else{
        this.regType=2
      }
    },
    codePhone(){
      if(!this.$common.checkPhone(this.phone)){
        this.$message({
          message: '请输入正确的11位手机号',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else{
        let that=this
        let params = new URLSearchParams();
        params.append('phone',that.phone)
        that.$ajax.post('sendSmsCode', params)
        .then(response=> {
          if(response.result){
            this.codeBtn=true
            let m=60
            let interval=setInterval(function(){
              m--
              that.codeValue=m+'秒后获取'
              if(m==0){
                that.codeBtn=false
                that.codeValue='获取验证码'
                clearInterval(interval)
              }
            },1000)
            this.$message({
              message:response.msg,
              type: 'success',
              offset:300,
              duration:1500
            });
          }else{
            this.$message({
              message:response.msg,
              type: 'error',
              offset:300
            });
          }
        })
      }
    },
    regComfirm(){
      if(!this.$common.checkPhone(this.phone)){
        this.$message({
          message: '请输入正确的11位手机号',
          type: 'warning',
          offset:300,
          duration:1500
        });
      }else if(this.smsCode==''){
        this.$message({
          message: '请输入验证码',
          type: 'warning',
          offset:300
        });
      }else{
        let that=this
        this.loading=true
        this.codeBtn=true
        let params = new URLSearchParams();
        params.append('phone',that.phone)
        params.append('name',that.name)
        params.append('password',that.password)
        params.append('smsCode',that.smsCode)
        that.$ajax.post('userRegister', params)
        .then(response=> {
          this.loading=false
          if(response.result){
            this.regType=3
          }else{
            this.$message({
              message:response.msg,
              type: 'error',
              offset:300
            });
          }
        }).catch(error=> {
          this.loading=false
        });
      }
    },
    loginBtn(){
      let that=this
      if(this.phone==''){
        this.$message({
          message: '用户名为必填项！',
          type: 'warning',
          offset:300
        });
      }else if(this.password==''){
        this.$message({
          message: '密码为必填项！',
          type: 'warning',
          offset:300
        });
      }else if(this.setCode!=this.code){
        this.$message({
          message: '验证码错误',
          type: 'warning',
          offset:300
        });
      }else{
        this.loading=true
        var params = new URLSearchParams();
        params.append('KEYDATA',that.phone+',fjlzy,'+that.password)
        that.$ajax.post('loginServer', params)
        .then(response=> {
          this.loading=false
          if(response.msg=='success'){
            sessionStorage.setItem('sessionId',response.sessionId)
            sessionStorage.setItem('token',response.user.token)
            that.verifyCode=''
          }else{
            this.$message({
              message: response.result,
              type: 'error',
              offset:300
            });
          }
        }).catch(error=> {
          this.loading=false
        });
      }
    },
  },
  created() {
      
  },
  mounted(){
    this.getCode()
  }
}
</script>
<style  lang="stylus">
.login
  .head
    height 120px
    background #fff
    color #333
    width 100%
    >div
      width: 900px;
      margin: 0 auto;
      img 
        cursor pointer
        // width 155px
        height 74px
        float: left;
        margin-top 25px
      .login-ent 
        a
          cursor pointer
          display inline-block
          float right
          width 80px
          color #333333
          text-align center
          font-size 18px
          margin 50px 0px
          &:nth-child(2)
            border-right 1px solid #333333
            margin-left 150px
  .alignmiddle 
    width 100%
    margin 0 auto
    height 700px
    font-size 14px
    .login-bg
      width 100%
      height 100%
      background url(../assets/img/login/loginBg.png) no-repeat center
      .reg-login
        position relative
        margin 0 auto
        width 1000px
        height 100%
        .left-toppike
          position: absolute;
          top: 71px;
          left: 0;
          width: 180px;
          height: 543px;
          .top-y
            display: inline-block;
            margin-left:185px;
            height: 100%;
            border: 1px solid #fff;
            -webkit-box-shadow: 0 0 10px rgba(255,255, 255, 1);
            -moz-box-shadow: 0 0 10px rgba(255,255, 255, 1);
            box-shadow: 0 0 10px rgba(255,255, 255, 1);
          .top-title
            height: 100%;
            width: 91%;
            position: absolute;
            top: 0;
            li 
              height: 30%;
              line-height: 9;
              text-align: center;
              a 
                color: #fff;
                font-size: 16px;
                text-decoration: none;
              .top-quan 
                display: inline-block;
                float: right;
                width: 36px;
                height: 36px;
                margin-top: 57px;
        .login 
          position absolute
          top 15%
          left 26%
          background-color: #fff
          width 530px
          border 2px solid #E6E6E6
          border-radius 10px
          text-align center
          padding-top 50px
          .el-loading-mask
            position: inherit
          >div
            margin-bottom 20px
            position relative
            input 
              width 260px
              height 46px
              border 1PX solid #E9E1E1
              border-radius 10px
              font-size 16px
              color #333333
              padding 0px 60px
            img 
              position absolute
              left 90px
              top 8px
            &:nth-child(3)
              input 
                width 200px
                padding 0px 20px
                margin-right 138px
              canvas
                width 109px
                height 50px
                border-radius 10px
                position absolute
                right 73px
            &:nth-child(4)
              text-align left
              font-size 14px
              margin 0px 80px
            &:nth-child(5)
              cursor pointer
              background: -webkit-linear-gradient(to right,#3DC2DE, #339CEA); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(to right,#3DC2DE,#339CEA); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(to right,#3DC2DE,#339CEA); /* Firefox 3.6 - 15 */
              background: linear-gradient(to right,#3DC2DE,#339CEA); /* 标准的语法 */
              color #fff
              font-size 20px
              width 380px
              height 50px
              line-height 50px
              border-radius 10px
              margin  30px auto 50px auto
        .register
          position absolute
          top 8%
          left 26%
          background-color: #fff
          width 530px
          height 560px
          border 2px solid #E6E6E6
          border-radius 10px
          text-align center
          .el-loading-mask
            position: inherit
          .phoneCode
            input 
              width 208px
              margin-right 20px
            button 
              width 112px
          >div
            margin-bottom 20px
            input 
              width 340px
              height 46px
              border 1PX solid #E9E1E1
              border-radius 10px
              font-size 16px
              color #333333
              padding 0px 20px
            &:first-child
              font-size 18px
              display flex
              color #333
              >div
                cursor pointer
                width 50%
                margin 20px 80px
                padding 10px 0px
                &:first-child
                  color #2DB9D4
                  border-bottom 2px solid #2DB9D4
            &:nth-child(6)
              input 
                width 200px
                padding 0px 20px
                margin-right 138px
              canvas
                width 109px
                height 50px
                border-radius 10px
                position absolute
                right 73px
            &:last-child
              position absolute
              cursor pointer
              background: -webkit-linear-gradient(to right,#3DC2DE, #339CEA); /* Safari 5.1 - 6.0 */
              background: -o-linear-gradient(to right,#3DC2DE,#339CEA); /* Opera 11.1 - 12.0 */
              background: -moz-linear-gradient(to right,#3DC2DE,#339CEA); /* Firefox 3.6 - 15 */
              background: linear-gradient(to right,#3DC2DE,#339CEA); /* 标准的语法 */
              color #fff
              font-size 20px
              width 380px
              height 50px
              line-height 50px
              border-radius 10px
              bottom 20px
              left 75px
  .login-foot
    background #E7E7E7
    height 260px
    >div
      width 980px
      margin 0 auto
      padding 60px 0px
      color #333
      font-size 14px
      .pull-left
        >div
          margin-bottom 10px
          &:first-child
            color #999
            font-size 12px
            width 506px
            margin-bottom 30px
      .pull-right
        text-align center
        margin-right 190px
        img 
          width 102px
          height 102px
          margin-top 10px
</style>
